/* eslint-disable @typescript-eslint/ban-ts-comment */
import React, { FC } from 'react';
import { Box, Flex } from '@chakra-ui/react';
import Helmet from 'react-helmet';
import Page from '../components/Page';

const Register: FC = () => {
  return (
    <Page
      seoOptions={{
        title: 'Sign up | CronPay',
        description: '',
        canonical: 'https://cronpay.io/sign-up/'
      }}
      maxW='100%'
      p={0}
      m={0}
    >
      <Flex direction={{ base: 'column', md: 'row' }} overflow='hidden' minH='100vh' height='100%'>
        <Box w={{ base: '100%', md: '3xl' }} mx='auto' py={{ base: '10', md: '16' }} px={{ base: '6', md: '10' }}>
          <Box alignContent='' mx='auto' id='getWaitlistContainer' data-waitlist_id='12013' />
          <Helmet>
            <link
              rel='stylesheet'
              type='text/css'
              href='https://prod-waitlist-widget.s3.us-east-2.amazonaws.com/getwaitlist.min.css'
            />
            <script src='https://prod-waitlist-widget.s3.us-east-2.amazonaws.com/getwaitlist.min.js' />
          </Helmet>
        </Box>
      </Flex>
    </Page>
  );
};

export default Register;
